import {event, indentity} from '../vendor/dynamicyield/dynamicyield.js';
import {parse} from '../smartpak/cookie.js';

const cdProfileCookie = parse('CDProfile', function(cookie) {
        ['PrimaryDiscipline', 'NextSmartPakShipDate', 'DateModified', 'CustomerFirstName', 'CustomerEmail'].forEach(
            function(key) {
                cookie[key] = cookie[key] ? cookie[key] : '';
            }
        );

        [
            'ExistingCustomer',
            'USEF',
            'AQHA',
            'IHSA',
            'BarnBuddy',
            'Canine',
            'HasHadSPs',
            'SPsNoHorseImage',
            'HasPassword',
            'HasActiveSubscription'
        ].forEach(function(key) {
            cookie[key] = !!cookie[key] && /(yes|true|1)/gi.test(cookie[key].toLowerCase());
        });

        cookie.ATSSmartPaks = cookie.ATSSmartPaks ? parseInt(cookie.ATSSmartPaks) : -1;
        cookie.HasATSSmartPaks = cookie.ATSSmartPaks > 0;
        cookie.HasMemberDiscount = cookie.AQHA || cookie.IHSA || cookie.USEF;
        cookie.UnSubSmartPaks = cookie.UnSubSmartPaks ? parseInt(cookie.UnSubSmartPaks) : -1;
        cookie.isWesternDiscipline = /western|reining|barrel racing/gi.test(cookie.PrimaryDiscipline);
        cookie.hasOnlyUnsubmittedSmartPaks = cookie.ATSSmartPaks <= 0 && cookie.UnSubSmartPaks > 0;
        cookie.hasOneSubmittedAndNoUnsubmittedSmartPaks = cookie.ATSSmartPaks === 1 && cookie.UnSubSmartPaks <= 0;
        cookie.hasMultipleSubmittedOrSubmittedAndUnsubmitted =
            cookie.ATSSmartPaks > 1 || (cookie.ATSSmartPaks > 0 && cookie.UnSubSmartPaks > 0);
        cookie.hasNoSmartPaks = cookie.ATSSmartPaks <= 0 && cookie.UnSubSmartPaks <= 0;
        cookie.qualifiesForSuggestions = cookie.HasHadSPs || cookie.UnSubSmartPaks > 0 || cookie.ATSSmartPaks > 0;
    }),
    dyCopy = {...cdProfileCookie};

    
    delete dyCopy.CustomerEmail;
    delete dyCopy.CustomerFirstName;
    
    event('CDprofile', dyCopy);
    indentity(cdProfileCookie.CustomerEmail);

export default cdProfileCookie;
